module.exports = __webpack_public_path__ + "img/purchase-icon-dark.adae0dd1.svg";